import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const ShieldChekmark = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M10 12L11.5 13.5L14.5 10.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 10.767C3.5 15.1925 6.2472 19.1532 10.3923 20.7036L10.4223 20.7148C11.4399 21.0954 12.5607 21.095 13.578 20.7138L13.6024 20.7047C17.7512 19.1499 20.5 15.1842 20.5 10.7536V7.03023C20.5 6.15536 19.9314 5.38202 19.0963 5.12118L12.5963 3.09095C12.208 2.96968 11.792 2.96968 11.4037 3.09095L4.90374 5.12112C4.06864 5.38195 3.5 6.15529 3.5 7.03017V10.767Z"
      />
    </svg>
  );
};
